import { UPDATE_RANGE } from './types';

export function updateRange(range) {
    return async function(dispatch) {       
        dispatch({type: UPDATE_RANGE, payload: range});
    }
}